export default "<div class=\"appRouter\" data-app-resizable-screen>\n  <div class=\"appRouter_view\" ng-view></div>\n</div>\n";